import { Ban, Paperclip } from "lucide-react";
import { Link } from "react-router-dom";

const money = (v, ccy) => `${ccy === "INR" ? "₹" : `${ccy} `}${v}`;
const TITLE = (s) => (s || "").replace(/_/g, " ").toLowerCase();

export const ExpenseCard = ({ expense: e, onVoid, busy }) => (
  <li
    data-testid={`expense-card-${e.expense_id}`}
    className={`rounded-lg border border-[#E4E0D8] bg-white p-3 ${e.status === "VOIDED" ? "opacity-60" : ""}`}
  >
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0">
        <Link to={`/expenses/${e.expense_id}`} data-testid={`expense-open-${e.expense_id}`} className="block min-w-0">
          <p className="text-[15px] font-semibold text-archival-primary capitalize truncate">{TITLE(e.category)}</p>
          <p className="text-[13px] text-archival-secondary truncate">{e.description || e.payee_name || "—"}</p>
        </Link>
        <p className="mt-1 flex flex-wrap items-center gap-2 text-[11px] text-archival-muted">
          <span data-testid={`expense-date-${e.expense_id}`}>{e.business_date}</span>
          <span className="rounded-full bg-archival-soft px-2 py-0.5 capitalize">{TITLE(e.payment_method)}</span>
          {e.cash_classification === "CASH" && (
            <span data-testid={`expense-cash-tag-${e.expense_id}`} className="rounded-full bg-emerald-50 px-2 py-0.5 text-emerald-800">cash</span>
          )}
          {e.source_evidence && <Paperclip size={11} aria-label="evidence attached" />}
          {e.backdated_reason && <span className="italic">backdated</span>}
        </p>
      </div>
      <div className="shrink-0 text-right">
        <p data-testid={`expense-amount-${e.expense_id}`} className="text-[17px] font-semibold tabular-nums text-archival-primary">
          {money(e.amount, e.currency)}
        </p>
        {e.status === "VOIDED" ? (
          <span data-testid={`expense-voided-${e.expense_id}`} className="mt-1 inline-block text-[11px] font-medium text-red-700">VOIDED</span>
        ) : (
          <button
            type="button"
            data-testid={`expense-void-btn-${e.expense_id}`}
            disabled={busy}
            onClick={() => onVoid(e)}
            className="mt-1 inline-flex items-center gap-1 text-[12px] font-medium text-red-700 hover:underline disabled:opacity-50"
          >
            <Ban size={12} /> Void
          </button>
        )}
      </div>
    </div>
    {e.void?.reason && (
      <p data-testid={`expense-void-reason-${e.expense_id}`} className="mt-2 rounded bg-red-50 px-2 py-1 text-[12px] text-red-800">
        Reversed · {e.void.reason}
      </p>
    )}
  </li>
);
